import Post from "../Post";

export default function loginByOtp(type, phoneOrEmail, temporaryToken, otp) {
  const params = {};
  if (type === "phone") {
    params.phone = phoneOrEmail;
  } else {
    params.email = phoneOrEmail;
  }
  return Post("user/getTokenByOTP", {
    ...params,
    temporaryToken: temporaryToken,
    OTP: otp,
  });
}
